// material ui
import { Drawer } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// shared components
import { NavigationTree } from '@/components/navigation';
import type { NavigationContext } from '@/components/navigation';

// relative
import { APPBAR_HEIGHT, DRAWER_MINI_WIDTH, DRAWER_WIDTH } from './constants';
import NavigationFooter from './NavigationFooter';

interface NavigationDrawerProps {
  isMobile: boolean;
  desktopOpen: boolean;
  mobileOpen: boolean;
  onMobileClose: () => void;
  navigationContext: NavigationContext;
  drawerBg: string;
  onOpenCookiePreferences: () => void;
}

export default function NavigationDrawer({
  isMobile,
  desktopOpen,
  mobileOpen,
  onMobileClose,
  navigationContext,
  drawerBg,
  onOpenCookiePreferences,
}: NavigationDrawerProps) {
  const theme = useTheme();

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          zIndex: (t) => t.zIndex.modal,
          // backgroundColor:
          //   theme.palette.mode === 'light'
          //     ? theme.palette.grey[0]
          //     : theme.palette.grey[1000],
          '& .MuiDrawer-paper': {
            width: '86vw',
            maxWidth: DRAWER_WIDTH,
            borderRight: 'none',
            bgcolor: drawerBg,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'hidden',
          },
        }}
      >
        <NavigationTree drawerOpen navigationContext={navigationContext} />
        <NavigationFooter
          drawerOpen
          onOpenCookiePreferences={onOpenCookiePreferences}
        />
      </Drawer>
    );
  }

  const desktopDrawerWidth = desktopOpen ? DRAWER_WIDTH : DRAWER_MINI_WIDTH;

  return (
    <Drawer
      variant="permanent"
      data-testid="desktop-drawer"
      sx={{
        flexShrink: 0,
        width: desktopDrawerWidth,
        '& .MuiDrawer-paper': {
          width: desktopDrawerWidth,
          overflowX: 'hidden',
          borderRight: 'none',
          boxSizing: 'border-box',
          borderRadius: 0,
          top: APPBAR_HEIGHT,
          height: `calc(100% - ${APPBAR_HEIGHT}px)`,
          bgcolor: drawerBg,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        },
      }}
    >
      <NavigationTree
        drawerOpen={desktopOpen}
        navigationContext={navigationContext}
      />
      {/* <NavigationFooter
        drawerOpen={desktopOpen}
        onOpenCookiePreferences={onOpenCookiePreferences}
      /> */}
    </Drawer>
  );
}
